import React from 'react';
import { ErrorMessage, useFormikContext } from 'formik';
import { Box, FormControl, TextField } from '@mui/material';
import { ImageAttachments } from '../../ImageAttachments';

const MultilineField = ({
    data,
    fieldValues,
    handleBlur,
    inGroup = false,
    isReadOnly = false,
    isSubmitAllow = true,
    handleClick = () => {},
}) => {
    const { setFieldValue, errors } = useFormikContext();

    const multilineData = (
        <FormControl
            style={{
                padding: '5px',
                width: data?.field_width ? data.field_width + '%' : '100%',
            }}
        >
            <Box display="flex" justifyContent="center" alignItems="center">
                {!isReadOnly && (
                    <TextField
                        id={data.variable}
                        name={data.variable}
                        value={fieldValues[data.variable]}
                        multiline
                        fullWidth
                        onChange={(e) => {
                            if (isSubmitAllow) {
                                setFieldValue(data.variable, e.target.value);
                            }
                        }}
                        onClick={(e) => {
                            if (!isSubmitAllow) {
                                e.stopPropagation();
                                handleClick(e, data);
                            }
                        }}
                        onBlur={() => isSubmitAllow && handleBlur(fieldValues)}
                        placeholder={data?.hide_label === true ? '' : data?.label}
                        label={data?.hide_label === true ? '' : data?.label}
                        rows={data?.lines ? data.lines : 3}
                        disabled={isReadOnly}
                        sx={{
                            '& .MuiInputBase-input.Mui-disabled': {
                                WebkitTextFillColor: '#000000',
                            },
                        }}
                        error={!!errors?.[data?.variable]}
                        helperText={errors?.[data?.variable]}
                        style={{ textAlign: 'left' }}
                    />
                )}
                {data.image_attachments_allow && (
                    <ImageAttachments
                        data={data}
                        var_name={data.variable}
                        level="field"
                        isReadOnly={!isSubmitAllow}
                        handleClick={handleClick}
                    />
                )}
            </Box>
            {!isReadOnly && (
                <ErrorMessage
                    style={{
                        color: '#E84C3C',
                        margin: '4px 14px',
                        fontSize: '0.75rem',
                        textAlign: 'left',
                        fontFamily: 'Open Sans',
                        fontWeight: 600,
                        lineHeight: 1.66,
                    }}
                    name={data.variable}
                    component="div"
                />
            )}
            {isReadOnly && (
                <div>
                    <label className={'multiline-readonly-label'}>{data?.hide_label === true ? '' : data?.label}</label>
                    <p className={'multiline-readonly'}>{fieldValues[data.variable] || ''}</p>
                </div>
            )}
        </FormControl>
    );

    return inGroup ? multilineData : <div style={{ width: '100%' }}>{multilineData}</div>;
};

export default MultilineField;
